import api from "./api";

// Task Status service (CRUD)
// GET    /task-status
// GET    /task-status/:id
// POST   /task-status
// PATCH  /task-status/:id
// DELETE /task-status/:id

export async function getTaskStatuses() {
  const res = await api.get("/task-status");
  return Array.isArray(res) ? res : [];
}

export async function getTaskStatusById(statusId) {
  if (statusId === undefined || statusId === null || statusId === "") {
    throw new Error("statusId is required");
  }
  const idNum = Number(statusId);
  if (!Number.isInteger(idNum)) throw new Error("statusId must be an integer");
  return api.get(`/task-status/${idNum}`);
}

export async function createTaskStatus(payload) {
  return api.post("/task-status", payload || {});
}

export async function updateTaskStatus(statusId, payload) {
  const idNum = Number(statusId);
  if (!Number.isInteger(idNum)) throw new Error("statusId must be an integer");
  const body = { ...(payload || {}) };
  delete body.id;
  return api.patch(`/task-status/${idNum}`, body);
}

export async function deleteTaskStatus(statusId) {
  const idNum = Number(statusId);
  if (!Number.isInteger(idNum)) throw new Error("statusId must be an integer");
  return api.delete(`/task-status/${idNum}`);
}
